module.exports = __webpack_public_path__ + "static/media/rss.c8b13b64.svg";